import { DevicePermission } from 'console/device/device_ts';
import { EventsTab } from './tab';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const events_tab_definition = {
    key: DefaultTabKey.eventsTab,
    title: 'События',
    iconclass: 'ui-icon-tab-events',
    should_appear: (device) => device?.has_access(DevicePermission.view_history),
    render: EventsTab,
};
